<template>
    <ModalBase @close="close" :withContent="true" :maxWidth="'default'">
        <loader :loading="true" v-if="loading"></loader>
        <h1>{{ trads.title }}</h1>
        <section>
            <TextInputBloc :min-length="MIN_LENGTH_NAME" :required="true" :label="trads.label" v-model="template.name"> </TextInputBloc>
        </section>
        <section>
            <h1>{{ trads.infos.title }}</h1>
            <p>{{ `${trads.infos.zone}: ${template.zone.name}` }}</p>
            <p>{{ `${trads.infos.standDesign}: ${template.standDesign.name}` }}</p>
            <p>{{ `${trads.infos.height}: ${template.height}` }}mm</p>
            <p>{{ `${trads.infos.width}: ${template.width}` }}mm</p>
        </section>
        <footer class="txtCenter">
            <ClientColorButton :disabled="$v.template.$invalid" @click="save">{{ $t("common.save") }}</ClientColorButton>
            <ClientColorButton :inactive-color="true" @click="close">{{ $t("common.cancel") }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { Context } from "plano_engine";
import planoService from "@/services/plano";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import { MAX_LENGTH_NAME, MIN_LENGTH_NAME } from "@/utils/string";
export default {
    data: () => ({
        MIN_LENGTH_NAME,
        template: {
            name: undefined,
            content: undefined,
            zone: undefined
        }
    }),
    validations: {
        template: {
            name: { required, max: maxLength(MAX_LENGTH_NAME), min: minLength(MIN_LENGTH_NAME) }
        }
    },
    components: { loader, ModalBase, ClientColorButton, TextInputBloc },
    mixins: [TryLoadMixin],
    props: {
        plano: {
            type: Object,
            required: true
        }
    },
    computed: {
        trads() {
            return this.$trad.plano.savePlanoAsTemplate;
        }
    },
    methods: {
        async save() {
            if (this.$v.template.$invalid) return false;
            this.template.content = Context.save();
            await this.tryLoad(() => planoService.savePlanoAsTemplate(this.plano.id, this.template));
            this.dialogSuccess(this.$t("saved"));
            this.close();
        },
        close() {
            this.$emit("close");
        }
    },
    created() {
        const { zone, height, width, stand_design } = this.plano;
        this.template = { ...this.template, zone, height, width, standDesign: stand_design };
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
section {
    margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// ModalSavePlanoAsTemplate.vue?2c0dae59